import {
	gridGutter,
	gridGutter1q6
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from '../../../../../../js/shared/new-theme';

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const pageFidelityPrograms = `
	padding: ${gridGutter}px;
	@media (max-width: 576px) {
		padding: 0 ${gridGutter1q6}px ${gridGutter}px;
	}
`;

export const pageFidelityProgramsFlex = `
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const pageFidelityProgramsSearch = `
	@media (max-width: 576px) {
		display: none;
	}
	display: flex;
	flex-direction: row;
    justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid ${theme.palette.gray[400].value};
	padding: 16px 32px;

	& p {
		max-width: 330px;
		margin: 0;
	};
	& input {
		max-width: 230px
	};
`;

export const pageFidelityProgramsSearchInput = `
	@media (max-width: 767px) {
		display: none;
	}
`;
